import { render, staticRenderFns } from "./DashboardFallback.vue?vue&type=template&id=1ff7053c&scoped=true&"
import script from "./DashboardFallback.vue?vue&type=script&lang=js&"
export * from "./DashboardFallback.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFallback.vue?vue&type=style&index=0&id=1ff7053c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7053c",
  null
  
)

export default component.exports